import Pusher from 'pusher-js';

import { envConfig } from '@/config';

let pusherInstance: Pusher | null = null;
let instanceId = 0;

export const getPusherInstance = () => {
  if (!pusherInstance) {
    instanceId += 1;

    console.log(
      `%c[Pusher][Singleton] Creating instance #${instanceId}`,
      'color: green; font-weight: bold'
    );

    pusherInstance = new Pusher(envConfig.pusherKey!, {
      cluster: 'ap2',
    });

    // Global socket logs
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pusherInstance.connection.bind('state_change', (states: any) => {
      console.log(`%c[Pusher][Socket] ${states.previous} → ${states.current}`, 'color: #2196f3');
    });

    pusherInstance.connection.bind('connected', () => {
      console.log('%c[Pusher][Socket] CONNECTED', 'color: green; font-weight: bold');
    });

    pusherInstance.connection.bind('disconnected', () => {
      console.log('%c[Pusher][Socket] DISCONNECTED', 'color: orange; font-weight: bold');
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pusherInstance.connection.bind('error', (err: any) => {
      console.error('[Pusher][Socket] ERROR', err);
    });
  } else {
    console.log('%c[Pusher][Singleton] Reusing existing instance', 'color: gray');
  }

  return pusherInstance;
};
